export class Bodega {

    public id:number;
    public codigoBodega:string;
    public nombre:string;
    public referencia1:string;
    public referencia2:string;
    public referencia3:string;    

}



// WEBPACK FOOTER //
// D:/Proyectos/tpl viejo prueba/eflowTPL/src/app/model/bodega.ts